import * as React from 'react';
import { analytics, AnalyticsButtonLabels, createRedirectEvent } from '@atlassian/temp-analytics';

import { DismissableInlineMessage, StyledTitle } from '@css-xp/base';

interface Props {
  adaUrl: string;
}

const MessageContent = ({ adaUrl }: Props) => (
  <p className="inline-message">
    CASSI only has notes issued since May 2019. We&apos;re in the process of bringing across all notes, until this time
    you can find notes earlier than <b>May 2019</b> in{' '}
    <a
      href={adaUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        analytics.sendUIEvent(createRedirectEvent(AnalyticsButtonLabels.ADA));
      }}
    >
      ADA
    </a>
    .
  </p>
);

const HistoricalNotesMessage = ({ adaUrl }: Props) => {
  return (
    <div className="inline-message-container">
      <div style={{ display: 'inline-block' }}>
        <DismissableInlineMessage
          renderTitle={(toggleMessage: () => void) => (
            <StyledTitle
              type="info"
              title="Can't find the notes you're looking for?"
              size="medium"
              onClick={toggleMessage}
            />
          )}
          renderMessage={() => <MessageContent adaUrl={adaUrl} />}
        />
      </div>
    </div>
  );
};

export default HistoricalNotesMessage;
